export const VFC_ENROLEMENT_YEARS_LESS_THAN = 19;
